const SELECTORS = {
    searchSortBy: Utility.DomSelector.$$('#sortby-search [name="sort_by"]'),
    searchForm: Utility.DomSelector.$('[data-search-container] form[role="search"]'),
    totalProducts: Utility.DomSelector.$('[data-search-container] [data-total-products]')
};

class TemplateSearchJS {
    constructor() {
      if (SELECTORS.searchForm) {
        SELECTORS.searchForm.addEventListener('submit', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          const query = SELECTORS.searchForm.querySelector('input[name="q"]')?.value.trim();
          if (!query) return;

          const baseUrl = globalThis.routes?.search_url || '/search';
          const params = new URLSearchParams(new FormData(SELECTORS.searchForm));
          params.set('q', query);
          window.location.assign(`${baseUrl}?${params.toString()}`);
        }, true);
      }

      if(SELECTORS.searchSortBy){
        SELECTORS.searchSortBy.forEach((input) =>{
            input.addEventListener('change', (_event)=>{
                const selectedRadio = Utility.DomSelector.$('#sortby-search [name="sort_by"]:checked');
                if (!selectedRadio) return;

                const currentParams = new URLSearchParams(window.location.search);
                currentParams.set('sort_by', selectedRadio.value);

                window.location.href = `${window.location.pathname}?${currentParams.toString()}`;
            });
        });
      }

      this._bindSearchaniseCountSync();
    }

    _bindSearchaniseCountSync() {
      const applyCount = (data) => {
        if (!data || typeof data.totalItems === 'undefined') return;
        this._updateProductCount(data);
      };

      if (globalThis.__searchaniseResultsData) {
        applyCount(globalThis.__searchaniseResultsData);
      }

      document.addEventListener('searchanise:count-updated', (event) => {
        applyCount(event.detail);
      });

      const bindResultsUpdated = () => {
        const snizeJquery = globalThis.Searchanise?.$;
        if (!snizeJquery) return false;

        snizeJquery(document)
          .off('Searchanise.ResultsUpdated.templateSearchCount')
          .on('Searchanise.ResultsUpdated.templateSearchCount', () => {
            if (globalThis.__searchaniseResultsData) {
              applyCount(globalThis.__searchaniseResultsData);
            }
          });

        return true;
      };

      if (!bindResultsUpdated()) {
        document.addEventListener('Searchanise.Loaded', bindResultsUpdated, { once: true });
      }
    }

    _updateProductCount(data) {
      const totalProductsEl = SELECTORS.totalProducts;
      if (!totalProductsEl) return;

      const totalItems = Number(data.totalItems) || 0;
      const startIndex = Number(data.startIndex) || 0;
      const pageSize = Number(data.itemsPerPage) || Number(data.currentItemCount) || 0;
      const currentItemCount = Number(data.currentItemCount) || (pageSize > 0 ? Math.min(pageSize, Math.max(totalItems - startIndex, 0)) : 0);
      const startCount = totalItems === 0 ? 0 : startIndex + 1;
      const endCount = totalItems === 0 ? 0 : Math.min(startIndex + currentItemCount, totalItems);
      const template = globalThis.searchPageStrings?.totalProducts
        || 'Showing {{ start_count }}–{{ end_count }} of {{ total_items }} items';
      const text = template
        .replace(/\{\{\s*start_count\s*\}\}/g, startCount)
        .replace(/\{\{\s*end_count\s*\}\}/g, endCount)
        .replace(/\{\{\s*total_items\s*\}\}/g, totalItems);

      const countParagraph = totalProductsEl.querySelector('p') || totalProductsEl;
      countParagraph.textContent = text;
    }
}

new TemplateSearchJS();
